export default "__VITE_ASSET__zBTilDLv__"